import { Button, Typography } from 'antd'
import React from 'react'

const PageHeader = ({ title = "Title Here", rightComp = null }) => {
    return (
        <div className="flex justify-between items-center">
            <Typography.Title level={4} className="mb-4">{title}</Typography.Title>
            {rightComp ? rightComp : null}
        </div>
    )
}

export default PageHeader